import { createContext, useContext, type ReactNode } from 'react';
import type { FeatureFlagName } from '~/lib/feature-flags';

type FeatureFlagContextValue = Record<string, boolean>;

const FeatureFlagContext = createContext<FeatureFlagContextValue | null>(null);

export function FeatureFlagProvider({
  flags,
  children,
}: {
  flags: Record<string, boolean>;
  children: ReactNode;
}) {
  return <FeatureFlagContext.Provider value={flags}>{children}</FeatureFlagContext.Provider>;
}

export function useFeatureFlag(flagName: FeatureFlagName): boolean {
  const context = useContext(FeatureFlagContext);
  if (context === null) {
    return false;
  }
  return context[flagName] ?? false;
}

export function useFeatureFlags(): Record<string, boolean> {
  const context = useContext(FeatureFlagContext);
  if (context === null) {
    return {};
  }
  return context;
}
